import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { fetchRefreshToken } from '../../components/api/api';
import { getCookieOptions } from '../../services/axiosInterceptor';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [continuee, setContinuee] = useState(true);
  const [currentUser, setCurrentUser] = useState(null);
  const [currentUserCookie, setCurrentUserCookie] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pathName, setPathName] = useState(window.location.pathname);

  const [RefreshCaptcha, setRefreshCaptcha] = useState(false);
  const [RegisterCaptcha, setRegisterCaptcha] = useState('');

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const [CookieToken, setCookieToken] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = Cookies.get('token', getCookieOptions());
      if (!storedValueToken) return '';
      try {
        return JSON.parse(storedValueToken);
      } catch {
        return '';
      }
    } else {
      return '';
    }
  });

  const [tokenLogin, setTokenLogin] = useState(() => {
    if (typeof window !== 'undefined') {
      const storedValueToken = localStorage.getItem('tokenLogin');
      if (!storedValueToken) return '';
      try {
        return JSON.parse(storedValueToken);
      } catch {
        return '';
      }
    } else {
      return '';
    }
  });

  useEffect(() => {
    const onAuthRequired = () => {
      // Switch app to login view without full reload
      setContinuee(false);
    };
    window.addEventListener('auth-required', onAuthRequired);
    return () => window.removeEventListener('auth-required', onAuthRequired);
  }, []);

  const isTokenExpired = (tokenProp) => {
    try {
      const decoded = jwtDecode(tokenProp);
      if (decoded.exp < Date.now() / 1000) {
        return true;
      } else return false;
    } catch (err) {
      return false;
    }
  };

  const checkEdame = async () => {
    try {
      const decodedToken = jwtDecode(CookieToken.accessToken);
      const newAccessToken = await fetchRefreshToken(
        CookieToken.refreshToken,
        decodedToken.email
      );
      if (newAccessToken) {
        setCookieToken(newAccessToken);
        localStorage.setItem('tokenLogin', JSON.stringify(newAccessToken));
      }
    } catch (error) {
      console.error('Error refreshing access token:', error);
      // Logout();
    }
  };

  const Logout = () => {
    localStorage.clear();
    Cookies.remove('token', getCookieOptions());
    setCurrentUser(null);
    setLoading(false);
    // Do not hard redirect; show login inline and keep current route
    setContinuee(false);
  };

  const GetLocalEdame = () => {
    if (process.env.REACT_APP_EDAME == 'false') {
      if (
        typeof window !== 'undefined' &&
        isTokenExpired(tokenLogin?.accessToken)
      ) {
        const edameRaw = localStorage.getItem('edame');
        if (edameRaw) {
          try {
            return JSON.parse(edameRaw);
          } catch {
            return false;
          }
        } else {
          return false;
        }
      } else {
        const edameRaw = localStorage.getItem('edame');
        if (edameRaw) {
          try {
            return JSON.parse(edameRaw);
          } catch {
            return false;
          }
        } else {
          return false;
        }
        localStorage.clear();
      }
    } else {
      return true;
    }
  };

  const getLocalStorager = () => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const listRaw = localStorage.getItem('list');
      if (listRaw && listRaw !== 'undefined') {
        try {
          return JSON.parse(listRaw);
        } catch {
          return [];
        }
      } else {
        return [];
      }
    }
  };

  return (
    <AuthContext.Provider
      value={{
        continuee,
        setContinuee,
        currentUser,
        setCurrentUser,
        currentUserCookie,
        setCurrentUserCookie,
        email,
        setEmail,
        password,
        setPassword,
        Logout,
        CookieToken,
        setCookieToken,
        checkEdame,
        GetLocalEdame,
        getLocalStorager,
        tokenLogin,
        setTokenLogin,
        pathName,
        setPathName,
        RefreshCaptcha,
        setRefreshCaptcha,
        RegisterCaptcha,
        setRegisterCaptcha,
        isTokenExpired,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => useContext(AuthContext);
